/**
 * Created by lu on 2018/5/4.
 */
var nb = require('../../../nb');
module.exports = nb.define({
    view: {
        'class': 'order-list clearfix',
        'data-status': nb.bind('status'),
        'data-id': nb.bind('id'),
        $html: [{
            'class': 'item-header',
            $html: [{
                'class': 'order-time',
                tag: 'span',
                $text: nb.bind('createTime')
            }, {
                'class': 'order-num',
                tag: 'span',
                $html: [{
                    tag: 'span',
                    $text: nb.bind('orderNoText')
                }, {
                    tag: 'span',
                    $text: nb.bind('orderNo')
                }]
            }, {
                'class': 'sales-name',
                tag: 'span',
                style: {
                    'display': nb.bind('sales-state')
                },
                $html: [{
                    tag: 'span',
                    $text: nb.bind('salesNameText')
                }, {
                    tag: 'span',
                    $text: nb.bind('salesName')
                }]
            }, {
                'class': 'order-total',
                $html: [{
                    tag: 'span',
                    $text: nb.bind('totalText')
                }, {
                    tag: 'span',
                    $text: nb.bind('amount')
                }]
            }, {
                'class': 'pay-way',
                $html: [{
                    tag: 'span',
                    $text: nb.bind('payWayText')
                }, {
                    tag: 'span',
                    $text: nb.bind('payType')
                }]
            }]
        }, {
            'class': 'item-content clearfix',
            'data-length': nb.bind('lengthState'),
            $html: [{
                'class': 'product-list',
                $type: nb.view.List,
                $model: 'productList'
            }, {
                'class': 'info-state',
                $html: [
                    {
                        'class': [nb.bind('lockClass'), 'order-status'],
                        'data-uk-dropdown': '{pos:"bottom-center"}',
                        $html: [{
                            'class': 'lock-text',
                            $text: nb.bind('statusText')
                        }, {
                            'class': 'uk-dropdown',
                            $text: nb.bind('lockTips')
                        }]
                    },
                    // {
                    //     'class': 'order-status',
                    //     $text: nb.bind('statusText')
                    // },
                    {
                        'class': 'order-detail',
                        tag: 'a',
                        target: '_blank',
                        // href:'orderDetail.html',
                        href: nb.bind('orderDetailHref'),
                        $text: nb.bind('text')
                    }]
            }, {
                'class': 'item-op clearfix',
                'data-id': nb.bind('id'),
                $html: [{
                    tag: 'a',
                    'class': 'to-play',//立即付款
                    // href: nb.bind('goPayHref'),
                    $text: nb.bind('goPayText')
                }, {
                    tag: 'a',
                    'class': 'to-confirm',
                    $text: nb.bind('affirmText')  //确认收货
                }, {
                    tag: 'a',
                    'class': ['to-cancel', nb.bind('cancelState')],
                    $text: nb.bind('cancelText')   //取消订单
                }, {
                    tag: 'a',
                    'class': 'to-see',           //查看物流
                    // href: nb.bind('logisticsHref'),
                    $text: nb.bind('logisticsText')
                }, {
                    tag: 'a',
                    'class': 'to-delete', //删除订单
                    $text: nb.bind('deleteText')
                }, {
                    tag: 'a',
                    'class': ['after-sales', nb.bind('afterSaleState')],
                    href: nb.bind('afterSaleHref'),   //申请退货
                    $text: nb.bind('afterSaleText')
                }]
            }, {
                'class': 'see-detail', //删除订单
                tag: 'a',
                href: nb.bind('orderDetailHref'),   //申请退货
                $text: nb.bind('seeMore')
                // $text:'查看更多商品'
            }]
        }]
    },
    method: {
        init: function () {
            var self = this;

            // this.$('btn-ask-price').on('click', function () {
            //     self.getModel().set('enquiryStatus');
            // })
        }
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/page/order/view/OrderListItem.js
// module id = 681
// module chunks = 3